import { render } from "./imex-frame.vue?vue&type=template&id=447eea46"
import script from "./imex-frame.vue?vue&type=script&lang=js"
export * from "./imex-frame.vue?vue&type=script&lang=js"

import "./imex-frame.vue?vue&type=style&index=0&id=447eea46&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__